import React, { FC } from 'react';
import { Box, Container, Flex, Text, Link } from '@radix-ui/themes';
import './Footer.css';

interface FooterProps { }

const Footer: FC<FooterProps> = () => (
  <Box className="Footer" data-testid="Footer">
    <Box asChild className='FooterWrapper' style={{ background: "#10ddc270" }} py="5">
      <footer>
        <Container>
          <Flex direction={{ initial: 'column', md: 'row' }} justify="center" align="center" gap="4">
            <Box p="2">
              <Text style={{ color: "#053b50" }}>
                Copyright © {new Date().getFullYear()}. &nbsp;
                <Link className="FooterText" href="#">Zafir.</Link>
              </Text>
            </Box>
            <Box p="2">
              <Text style={{ color: "#053b50" }}>
                Developed using React <i className="fab fa-react fa-2xl" style={{ color: "#053b50" }}></i>
              </Text>
            </Box>
          </Flex>
        </Container>
      </footer>
    </Box>
  </Box>
);

export default Footer;
